import { Button, Heading, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ForbiddenPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <VStack
      height={"100vh"}
      justifyContent="center"
      alignItems="center"
      gap={4}
    >
      <Heading mb={1} as="h1" fontSize={30} fontWeight={600}>
        {t("forbidden_page.forbidden")}
      </Heading>
      <Button
        mt={4}
        bg="primary.DEFAULT"
        color="white"
        onClick={() => navigate("/")}
      >
        {t("common.buttons.go_back")}
      </Button>
    </VStack>
  );
}
